<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<contentblocks :items="page.contentblocks" />

		<usp-block v-if="page.uSPBlock" :header="page.uSPBlock.header" :items="page.uSPBlock.items" />

		<locations-overview :items="hotels" type="hotels" />

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

useRemoveFormitable();

const { data: locationsData } = await useWebsiteFetch('locations', {
	query: { language: locale.value },
	key: `${locale.value}/locations`,
});

const hotels = locationsData.value.filter((item) => item.type.toLowerCase() === 'hotels');
</script>

<style lang="scss" scoped>
:deep(h1) {
	color: var(--cta-color-blue);
}

:deep(.usp-block) {
	background: var(--light-background-color);

	h2 {
		color: var(--header-color-secondary);
	}
}
</style>
